import React from 'react';
import PropTypes from 'prop-types';
import { ContentShape } from 'entities/step-children/shape';
import { COLOR_MODES } from 'lib/user-preferences';
import {
  BLOCK_MODES,
  OPTION_SELECT,
  RATING,
  RATING_STAR,
  RATING_EMOJI,
  RATING_NUMBER,
} from 'lib/block';
import SelectContainer from 'components/Editor/Containers/SelectContainer';
import RatingContainer from 'components/Editor/Containers/RatingContainer';

const SELECT_TYPES = BLOCK_MODES[OPTION_SELECT];
const RATING_TYPES = [RATING, RATING_STAR, RATING_EMOJI, RATING_NUMBER];

const SelectType = ({ id, colorMode, ratingType, selectMode, ...props }) => {
  if (RATING_TYPES.includes(ratingType)) {
    return (
      <RatingContainer
        id={id}
        colorMode={colorMode}
        ratingType={ratingType}
        {...props}
      />
    );
  }

  if (SELECT_TYPES.includes(selectMode)) {
    return (
      <SelectContainer
        id={id}
        colorMode={colorMode}
        selectMode={selectMode}
        {...props}
      />
    );
  }

  return null;
};

SelectType.propTypes = {
  id: PropTypes.string,
  colorMode: PropTypes.oneOf(COLOR_MODES),
  content: ContentShape,
  ratingType: PropTypes.oneOf(RATING_TYPES),
  selectMode: PropTypes.oneOf(SELECT_TYPES),
};

export default SelectType;
